import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
//import { parseRawData } from '../../parsers';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import _ from 'lodash';
import { getSalesAttribute, getSalesAttributionFeatureLevelData } from 'gqlQueries/growthAnalysisQueries';
import { salesAttributeDataParser, salesAttributionFeatureLevelParser } from 'parser/salesAttributionDataParser';

const errorMessage: string = 'Something went wrong!';

function useFetchSalesAttributionFeatureLevel() {
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);
    const { appConfig } = useContext(UserContext);
    const growthAnalysisConfig = getConfig('growthAnalysis', appConfig);
    const salesAttributionDrillDownChartKeyValueMapping =
        growthAnalysisConfig.salesAttributionDrillDownChartKeyValueMapping;
    const [
        fetchAttributeSales,
        { data: attributeSalesData, loading: attributeSalesLoading, error: attributeSalesError },
    ] = useLazyQuery(getSalesAttributionFeatureLevelData, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getSalesAttributionFeatureLevel: featureGroup } = payload;
            //const featureGroup = payload;
            //if data present parse it
            if (featureGroup && 'featureLevelData' in featureGroup) {
                const parsedData = salesAttributionFeatureLevelParser(
                    featureGroup?.featureLevelData,
                    'featureValue',
                    'featureName',
                    true,
                    salesAttributionDrillDownChartKeyValueMapping,
                );
                setData(parsedData);

                return;
            }
            setData(null);
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        //sending empty data to error to avoid null data being sent
        setData(null);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        fetchAttributeSales: (variables: any) => {
            setLoading(true);
            setData(null);
            //onFetchComplete(dummyData);
            fetchAttributeSales(variables);
        },
    };
}

export { useFetchSalesAttributionFeatureLevel };
